import React from "react";
import { useNavigate } from "react-router-dom"
import { ReactComponent as UnauthorizedLogo } from '../asset/unauthorized.svg';
import Controls from "../components/controls/Controls";

function UnauthorizedScreen() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <div className='flex flex-col justify-center items-center space-y-4'>
            <UnauthorizedLogo />
            <Controls.Button text={`Revenir`} onClick={() => goBack()} />
        </div>
    );
}

export default UnauthorizedScreen;